import bp from './brakePoints';
import debounce from 'debounce';

let children = document.querySelectorAll('.js-main-menu-child'),
	parentButtons = function() {
		return Array.prototype.slice.call(document.querySelectorAll('[aria-haspopup="true"]'));
	},
	mobileMenu = document.querySelector('.js-mobile-menu');


parentButtons().forEach(item => {
	item.addEventListener('click', function() {
		if (item.getAttribute('aria-expanded')) {
			item.removeAttribute('aria-expanded');
		} else {
			closeMainSiblings(item);
			
		}
	});
});

function onResize() {
	children.forEach(function(item) {
		let inner = item.querySelector('.js-main-menu-child-inner');
		item.style.setProperty('--child-height', inner.offsetHeight + 'px');
	});
}

window.addEventListener('resize', debounce(onResize, 100), false);
onResize();

window.addEventListener('bpChanged', function() {
	hideMobileMenu();
	closeMainSiblings();
}, false);

// close main menu submenu and mobile menu on document click
$(document).click(function(e) {
	if (!e.target.closest('.js-mobile-menu') && !e.target.closest('.js-main-menu')) {
		let expandedMenuParent = parentButtons().filter(item => item.getAttribute('aria-expanded'));

		if (!!e.target.closest('.mobile-menu-toggle') && !mobileMenu.classList.contains('visible')) {
			hideMobileMenu();
			e.preventDefault();
		}
		
		// close child items
		if (expandedMenuParent.length > 0) {
			expandedMenuParent[0].removeAttribute('aria-expanded');
			e.preventDefault();
		}
	}
});

function closeMainSiblings(item = false) {
	parentButtons().forEach(item => item.removeAttribute('aria-expanded'));
	if (item) {
		item.setAttribute('aria-expanded', true);
	}
}

function hideMobileMenu() {
	mobileMenu.classList.remove('visible');
}
